import { Box, Stack, Typography } from "@mui/material";
import { Colors } from "Components/Layout/Themes/Colors";
import { BatchPaymentStatusChip } from "Components/BatchPayments/BatchPaymentStatusChip";
import type { BatchPaymentListItemDto } from "Infrastructure/Api/Api";
import { Link } from "Navigation/Link";
import { Resources, useResource } from "Translations/Resources";
import { formatCurrency } from "Utils/CurrencyUtils";
import { formatTransactionDateTime } from "Utils/DateUtils";
import { appUrl } from "Utils/UrlUtils";

const RESOURCES = Resources.Banking.BatchPayments;

type Props = {
  item: BatchPaymentListItemDto;
};

export const BatchPaymentRow = ({ item }: Props) => {
  const { t } = useResource();
  const {
    publicId,
    paymentCount,
    status,
    totalAmount,
    currencyCode,
    dateCreated,
  } = item;

  return (
    <Link
      to={`${appUrl("batch-payment-detail")}/${publicId}`}
      style={{ all: "unset" }}
    >
      <Box
        component="span"
        display="flex"
        width="100%"
        mt={2.5}
        pb={1.5}
        sx={{ cursor: "pointer" }}
        borderBottom={`1px solid ${Colors.MediumGrey}`}
        justifyContent="space-between"
      >
        <Stack component="span" gap={0.5} textAlign="left">
          <Typography component="span" fontSize="0.875rem">
            {paymentCount} {t(RESOURCES.PaymentCount).toLowerCase()}
          </Typography>
          <BatchPaymentStatusChip status={status} />
        </Stack>
        <Stack component="span" alignItems="flex-end" gap={0.5}>
          <Typography component="span" fontWeight={600}>
            {formatCurrency({ amount: totalAmount, currencyCode })}
          </Typography>
          <Typography
            component="span"
            fontSize="0.75rem"
            color={Colors.TextLight}
          >
            {formatTransactionDateTime(dateCreated)}
          </Typography>
        </Stack>
      </Box>
    </Link>
  );
};
